import cryptoJS from 'crypto-js';
import {
    doTagCreditCardOfferAccepted,
    doTagCreditCardOfferNotAccepted,
    doTagNotResident,
    doTagRegisterSuccess,
    doTagRegisterSuccessButtonClick,
} from 'components/newAccountSteps/initialStep/tagging';

export const useSaveRegisterRequests = (flags, userProfile, actions, onSavedCallback, wealthProduct = undefined) => {
    const checkboxEvent = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        if (userProfile.creditCardOffer_accepted) {
            doTagCreditCardOfferAccepted(userProfile, docNumberEncrypted);
        } else {
            doTagCreditCardOfferNotAccepted(userProfile, docNumberEncrypted);
        }
    };

    const handleSaveRequest = recaptcha => {
        const { docNumber } = userProfile;

        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        if (!userProfile.jointHolderForm) {
            actions.saveRegisterRequest({ ...userProfile, recaptcha }, wealthProduct, saved => {
                onSavedCallback(flags, saved, userProfile);
            });
        } else {
            actions.saveJointHolderRegisterRequest(userProfile, saved => {
                onSavedCallback(flags, saved, userProfile);
            });
        }
        doTagRegisterSuccess(userProfile, docNumberEncrypted);
        doTagRegisterSuccessButtonClick(userProfile, docNumberEncrypted);

        checkboxEvent();
    };

    const handleSaveNoResidentRequest = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        actions.saveNoResidentRequest(userProfile);
        doTagNotResident(userProfile, docNumberEncrypted);
        checkboxEvent();
    };

    return { handleSaveRequest, handleSaveNoResidentRequest };
};
